// Generat automat din README.md
import React, { useState, useEffect } from 'react';
import { MessageSquare, Users, Send, Search, Phone, MoreVertical, Clock, CheckCheck, Check, Image, Paperclip, Smile } from 'lucide-react';
import Card from '../../components/Card';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const IntegrareWhatsApp = () => {
  const [selectedChat, setSelectedChat] = useState(null);
  const [newMessage, setNewMessage] = useState('');
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // Mock data pentru WhatsApp
  const whatsappData = {
    stats: {
      totalContacts: 1247,
      activeChats: 23,
      messagestoday: 156,
      responseTime: '2.3 min'
    },
    conversations: [
      {
        id: 1,
        contact: {
          name: 'Maria Popescu',
          phone: '+40721234567',
          avatar: null,
          status: 'online',
          lastSeen: 'acum 2 min'
        },
        lastMessage: {
          text: 'Mulțumesc pentru informații! Când pot să trec să ridic produsul?',
          timestamp: '10:45',
          from: 'client',
          status: 'delivered'
        },
        unreadCount: 2,
        isActive: true
      },
      {
        id: 2,
        contact: {
          name: 'Ion Georgescu',
          phone: '+40731456789',
          avatar: null,
          status: 'offline',
          lastSeen: 'ieri la 18:30'
        },
        lastMessage: {
          text: 'Am trimis documentele solicitate prin email.',
          timestamp: 'ieri',
          from: 'business',
          status: 'read'
        },
        unreadCount: 0,
        isActive: false
      },
      {
        id: 3,
        contact: {
          name: 'Ana Ionescu',
          phone: '+40741987654',
          avatar: null,
          status: 'online',
          lastSeen: 'acum 5 min'
        },
        lastMessage: {
          text: 'Bună ziua! Vreau să aflu mai multe despre serviciile dumneavoastră.',
          timestamp: '09:15',
          from: 'client',
          status: 'delivered'
        },
        unreadCount: 1,
        isActive: false
      }
    ],
    messages: [
      {
        id: 1,
        chatId: 1,
        text: 'Bună ziua! Am văzut anunțul dumneavoastră și sunt interesată de produs.',
        timestamp: '10:30',
        from: 'client',
        status: 'delivered'
      },
      {
        id: 2,
        chatId: 1,
        text: 'Bună ziua! Vă mulțumesc pentru interes. Cu drag vă ofer toate detaliile necesare.',
        timestamp: '10:32',
        from: 'business',
        status: 'read'
      },
      {
        id: 3,
        chatId: 1,
        text: 'Produsul este disponibil în stoc și poate fi ridicat astăzi între 10:00-18:00.',
        timestamp: '10:33',
        from: 'business',
        status: 'read'
      },
      {
        id: 4,
        chatId: 1,
        text: 'Prețul este 250 RON și include garanția de 2 ani.',
        timestamp: '10:34',
        from: 'business',
        status: 'read'
      },
      {
        id: 5,
        chatId: 1,
        text: 'Mulțumesc pentru informații! Când pot să trec să ridic produsul?',
        timestamp: '10:45',
        from: 'client',
        status: 'delivered'
      }
    ],
    templates: [
      {
        id: 1,
        name: 'Salut Inițial',
        category: 'greeting',
        text: 'Bună ziua! Vă mulțumim că ne-ați contactat. Echipa noastră vă va răspunde în cel mai scurt timp.'
      },
      {
        id: 2,
        name: 'Confirmare Comandă',
        category: 'order',
        text: 'Comanda dumneavoastră #{{order_id}} a fost confirmată și va fi procesată în 24 de ore.'
      },
      {
        id: 3,
        name: 'Program Lucru',
        category: 'info',
        text: 'Programul nostru de lucru este Luni-Vineri: 09:00-18:00, Sâmbătă: 09:00-14:00.'
      }
    ]
  };

  const [messages, setMessages] = useState(whatsappData.messages);
  
  const filteredConversations = whatsappData.conversations.filter(conv =>
    conv.contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    conv.contact.phone.includes(searchTerm)
  );

  const handleSendMessage = () => {
    if (!newMessage.trim() || !selectedChat) return;

    const newMsg = {
      id: Date.now(),
      chatId: selectedChat.id,
      text: newMessage,
      timestamp: new Date().toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' }),
      from: 'business',
      status: 'sent'
    };

    setMessages(prev => [...prev, newMsg]);
    setNewMessage('');

    // Simulate status change after 2 seconds
    setTimeout(() => {
      setMessages(prev => 
        prev.map(msg => 
          msg.id === newMsg.id ? { ...msg, status: 'delivered' } : msg
        )
      );
    }, 2000);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'sent': return <Check className="w-3 h-3 text-gray-400" />;
      case 'delivered': return <CheckCheck className="w-3 h-3 text-gray-400" />;
      case 'read': return <CheckCheck className="w-3 h-3 text-blue-500" />;
      default: return <Clock className="w-3 h-3 text-gray-400" />;
    }
  };

  const selectedChatMessages = messages.filter(msg => 
    selectedChat ? msg.chatId === selectedChat.id : false
  );

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Integrare WhatsApp Business</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Comunicare automatizată cu clienții prin WhatsApp Business API
          </p>
        </div>
        <div className="flex space-x-3">
          <button 
            className="btn-secondary"
            onClick={() => setShowTemplateModal(true)}
          >
            <MessageSquare className="w-4 h-4 mr-2" />
            Template-uri
          </button>
          <button className="btn-primary">
            <Phone className="w-4 h-4 mr-2" />
            Contact Nou
          </button>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card title="Total Contacte" subtitle="În baza de date" icon={Users}>
          <div className="text-2xl font-bold text-primary-600">{whatsappData.stats.totalContacts}</div>
          <div className="text-sm text-green-600">+15 această săptămână</div>
        </Card>
        <Card title="Conversații Active" subtitle="În desfășurare" icon={MessageSquare}>
          <div className="text-2xl font-bold text-primary-600">{whatsappData.stats.activeChats}</div>
          <div className="text-sm text-blue-600">7 necesită răspuns</div>
        </Card>
        <Card title="Mesaje Astăzi" subtitle="Trimise și primite" icon={Send}>
          <div className="text-2xl font-bold text-primary-600">{whatsappData.stats.messagestoday}</div>
          <div className="text-sm text-green-600">+23% față de ieri</div>
        </Card>
        <Card title="Timp Răspuns" subtitle="Mediu de răspuns" icon={Clock}>
          <div className="text-2xl font-bold text-primary-600">{whatsappData.stats.responseTime}</div>
          <div className="text-sm text-green-600">Sub target de 5 min</div>
        </Card>
      </div>

      {/* WhatsApp Chat Interface */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Conversations List */}
        <div className="lg:col-span-1">
          <Card title="Conversații" className="h-96">
            <div className="mb-4">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="Caută conversație..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 w-full border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white text-sm"
                />
              </div>
            </div>
            
            <div className="space-y-2 max-h-80 overflow-y-auto">
              {filteredConversations.map((conversation) => (
                <div
                  key={conversation.id}
                  onClick={() => setSelectedChat(conversation)}
                  className={`p-3 rounded-lg cursor-pointer transition-colors ${
                    selectedChat?.id === conversation.id
                      ? 'bg-primary-50 dark:bg-primary-900/20 border-l-4 border-primary-500'
                      : 'hover:bg-gray-50 dark:hover:bg-gray-700'
                  }`}
                >
                  <div className="flex items-center space-x-3">
                    <div className="relative">
                      <div className="w-10 h-10 bg-gray-300 dark:bg-gray-600 rounded-full flex items-center justify-center">
                        <span className="text-sm font-medium">
                          {conversation.contact.name.charAt(0)}
                        </span>
                      </div>
                      {conversation.contact.status === 'online' && (
                        <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 border-2 border-white dark:border-gray-800 rounded-full"></div>
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between">
                        <h4 className="font-medium text-gray-900 dark:text-white text-sm truncate">
                          {conversation.contact.name}
                        </h4>
                        <span className="text-xs text-gray-500">
                          {conversation.lastMessage.timestamp}
                        </span>
                      </div>
                      <div className="flex items-center justify-between mt-1">
                        <p className="text-sm text-gray-600 dark:text-gray-400 truncate">
                          {conversation.lastMessage.text}
                        </p>
                        {conversation.unreadCount > 0 && (
                          <Badge variant="error" className="text-xs">
                            {conversation.unreadCount}
                          </Badge>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>

        {/* Chat Window */}
        <div className="lg:col-span-2">
          <Card className="h-96">
            {selectedChat ? (
              <>
                {/* Chat Header */}
                <div className="flex items-center justify-between p-4 border-b dark:border-gray-700">
                  <div className="flex items-center space-x-3">
                    <div className="relative">
                      <div className="w-10 h-10 bg-gray-300 dark:bg-gray-600 rounded-full flex items-center justify-center">
                        <span className="text-sm font-medium">
                          {selectedChat.contact.name.charAt(0)}
                        </span>
                      </div>
                      {selectedChat.contact.status === 'online' && (
                        <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 border-2 border-white dark:border-gray-800 rounded-full"></div>
                      )}
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900 dark:text-white">
                        {selectedChat.contact.name}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {selectedChat.contact.status === 'online' 
                          ? 'online' 
                          : `văzut ${selectedChat.contact.lastSeen}`
                        }
                      </p>
                    </div>
                  </div>
                  <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg">
                    <MoreVertical className="w-4 h-4" />
                  </button>
                </div>

                {/* Messages */}
                <div className="flex-1 p-4 space-y-4 max-h-60 overflow-y-auto">
                  {selectedChatMessages.map((message) => (
                    <div
                      key={message.id}
                      className={`flex ${message.from === 'business' ? 'justify-end' : 'justify-start'}`}
                    >
                      <div
                        className={`max-w-xs lg:max-w-md px-4 py-2 rounded-lg ${
                          message.from === 'business'
                            ? 'bg-primary-500 text-white'
                            : 'bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white'
                        }`}
                      >
                        <p className="text-sm">{message.text}</p>
                        <div className={`flex items-center justify-end mt-1 space-x-1 ${
                          message.from === 'business' ? 'text-white/70' : 'text-gray-500'
                        }`}>
                          <span className="text-xs">{message.timestamp}</span>
                          {message.from === 'business' && getStatusIcon(message.status)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Message Input */}
                <div className="p-4 border-t dark:border-gray-700">
                  <div className="flex items-center space-x-2">
                    <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg">
                      <Paperclip className="w-4 h-4 text-gray-500" />
                    </button>
                    <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg">
                      <Image className="w-4 h-4 text-gray-500" />
                    </button>
                    <input
                      type="text"
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                      placeholder="Scrie un mesaj..."
                      className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
                    />
                    <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg">
                      <Smile className="w-4 h-4 text-gray-500" />
                    </button>
                    <button
                      onClick={handleSendMessage}
                      disabled={!newMessage.trim()}
                      className="p-2 bg-primary-500 hover:bg-primary-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg transition-colors"
                    >
                      <Send className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <MessageSquare className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                    Selectează o conversație
                  </h3>
                  <p className="text-gray-500">
                    Alege o conversație din lista din stânga pentru a începe să comunici cu clienții.
                  </p>
                </div>
              </div>
            )}
          </Card>
        </div>
      </div>

      {/* Recent Activity */}
      <Card title="Activitate Recentă" subtitle="Ultimele acțiuni WhatsApp Business">
        <div className="space-y-3">
          <div className="flex items-center space-x-4 p-3 bg-green-50 dark:bg-green-900/20 rounded-lg">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-900 dark:text-white">
                Mesaj trimis către Maria Popescu
              </p>
              <p className="text-xs text-gray-500">Acum 5 minute</p>
            </div>
            <Badge variant="success">Livrat</Badge>
          </div>
          
          <div className="flex items-center space-x-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-900 dark:text-white">
                Contact nou adăugat: Ana Ionescu
              </p>
              <p className="text-xs text-gray-500">Acum 15 minute</p>
            </div>
            <Badge variant="info">Nou</Badge>
          </div>
          
          <div className="flex items-center space-x-4 p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
            <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-900 dark:text-white">
                Template "Confirmare Comandă" folosit 3 ori
              </p>
              <p className="text-xs text-gray-500">Astăzi</p>
            </div>
            <Badge variant="warning">Popular</Badge>
          </div>
        </div>
      </Card>

      {/* Templates Modal */}
      <Modal
        isOpen={showTemplateModal}
        onClose={() => setShowTemplateModal(false)}
        title="Template-uri Mesaje"
      >
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Template-uri rapide pentru mesaje comune
            </p>
            <button className="btn-primary btn-sm">
              <MessageSquare className="w-3 h-3 mr-1" />
              Nou
            </button>
          </div>
          
          <div className="space-y-3 max-h-60 overflow-y-auto">
            {whatsappData.templates.map((template) => (
              <div key={template.id} className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-medium text-gray-900 dark:text-white">
                    {template.name}
                  </h4>
                  <Badge variant="default" className="text-xs">
                    {template.category}
                  </Badge>
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                  {template.text}
                </p>
                <div className="flex space-x-2">
                  <button 
                    className="btn-primary btn-sm"
                    onClick={() => {
                      setNewMessage(template.text);
                      setShowTemplateModal(false);
                    }}
                  >
                    Folosește
                  </button>
                  <button className="btn-secondary btn-sm">
                    Editează
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default IntegrareWhatsApp;